<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.notification.createEdit')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <b-card no-body class="mb-1">
                    <b-card-header header-bg-variant="light" header-tag="header" role="tab" class="text-capitalize">
                        <div class="card-title">
                            {{ title }} {{$t('form.notification.template')}}
                        </div>
                        <div class="float-right">
                            <b-button @click="$router.go(-1)">{{$t('button.goBack')}}</b-button>
                            <b-button variant="primary" @click="submit()">{{$t('button.save')}}</b-button>
                        </div>
                    </b-card-header>

                    <b-card-body>
                         <div class="form-group">
                            <label>{{$t('form.notification.title')}}<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="title">
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.type')}}<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="type">
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.status')}}<span class="text-danger">*</span></label>
                            <select v-model="status" class="form-control">
                                <option value="1">{{$t('form.notification.activate')}}</option>
                                <option value="0">{{$t('form.notification.deactivate')}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.subject')}}<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="subject">
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.message')}}<span class="text-danger">*</span></label>
                            <summernote v-model="body"></summernote>
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.available_variables')}}<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="variables">
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
    import summernote from '../../../components/Summernote';
    import {
        required,
        maxLength,
        minLength
    } from "vuelidate/lib/validators";
    export default {
        props: ["permissions"],
        components: {
            summernote
        },
        mounted() {
            if (!this.permissions.createNotificationsEditor) {
                return this.$router.push('/');
            }
        },
        data() {
            return {
                alert: false,
                alertClass: null,
                alertMessage: null,
                isLoading: false,
                fullPage: true,
                closing: true,
                title:'',
                type:'',
                status: '',
                subject: '',
                body: '',
                variables:'',
            };
        },
        validations: {
            type: {
                required,
                maxLength: maxLength(100),
                minLength: minLength(1)
            },
            title: {
                required,
                maxLength: maxLength(100),
                minLength: minLength(1)
            },
            subject: {
                required,
                maxLength: maxLength(191)
            },
            body: {
                required,
            },
            status: {
                required,
            },

        },
               
        methods: {
            /**
             * Submit templates data to server
             */
            submit() {

            this.$v.$touch();


                if (this.$v.$invalid) {
                let errorMsg = "";
           

                if (this.$v.title.$error) {
                    errorMsg = "Title";
                }

                if (this.$v.subject.$error) {
                    errorMsg = errorMsg ? errorMsg + ", Subject" : "Subject";
                }

                 if (this.$v.type.$error) {
                    errorMsg = errorMsg ? errorMsg + ", Type" : "Type";
                }

                if (this.$v.body.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + ", Body"
                        : "Body";
                }

                if (this.$v.status.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + " and Status"
                        : "Status";
                }

                if (errorMsg !== "") {
                    this.showAlert(
                        this.$t("form.validation.mandatoryFieldsError", {
                            errors: errorMsg
                        }),
                        "danger"
                    );
                    return;
                }
            }

            
                const data = { 
                                title: this.title, 
                                type: this.type, 
                                slug: this.slug, 
                                subject:this.subject, 
                                body:this.body, 
                                status:this.status,
                                variables:this.variables
                                };

                this.isLoading = true;
                axios.post("/api/notification/templates", data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.success) {
                            this.showAlert(response.data.message);
                            setTimeout(() => this.$router.push({
                                name: 'NotificationEditor'
                            }), 1500)
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            /**
             * Show alert
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

       
    };

</script>
